// extracted by mini-css-extract-plugin
export default {"personal-cases":"index_personal-cases__kbX0E"};